"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
const useStyles = (0, _core.makeStyles)({
  root: {
    textAlign: 'center',
    '& .MuiTypography-root': {
      display: 'flex'
    }
  }
});
var _default = exports.default = useStyles;